class SlideOver {
	constructor(element) {
		this.card = element;
		this.toggler = null;
		this.state = null;
		this.bodyInner = document.querySelector('#page');
		this.defaultOverflow = this.bodyInner.style.overflowY || 'auto';

		this.topSnap = 40;
		this.botSnap = window.innerHeight - 86; // 86 is the height of navbar + SlideOver toggler
		this.height = this.topSnap + this.botSnap;

		this.yDown = null;
	}

	render(defaultState = 'closed') {
		if (!this.card) return;
		this.card.style.display = 'block';
		this.card.classList.add('slide-over');
		this.card.style.height = `${this.height}px`;

		// Set default state
		switch (defaultState) {
			case 'open':
				this.open();
				break;
			case 'hidden':
				this.hide();
				break;
			case 'closed':
			default:
				this.close();
				break;
		}

		this.wrapInner();
		this.appendToggler();
		this.registerEvents();
	}

	registerEvents() {
		// For touch devices, register swipe events
		document.addEventListener('touchstart', this.touchStart.bind(this));
		document.addEventListener('touchmove', this.touchMove.bind(this));
		// On click toggle button
		this.card.addEventListener('click', this.toggle.bind(this));
		// On click outside modal
		document.addEventListener('click', this.close.bind(this));
		this.inner.addEventListener('click', e => e.stopPropagation());
		document
			.querySelector('#navbar')
			.addEventListener('click', e => e.stopPropagation());

		// Listen to emitted events
		document.addEventListener('slide-over-open', this.open.bind(this));
		document.addEventListener('slide-over-close', this.close.bind(this));
		document.addEventListener('slide-over-hide', this.hide.bind(this));
		// On window resize, update heights
		window.addEventListener('resize', this.handleResizing.bind(this));
	}

	handleResizing() {
		if (this.moving) return;

		// Set new botSnap
		this.botSnap = window.innerHeight - 100;
		// Calculate new height
		this.height = this.topSnap + this.botSnap;
		// Set the new height to the slide-over
		this.card.style.height = `${this.height}px`;
		// If the slide-over is closed, set the transform to the new botSnap
		if (this.state === 'closed') {
			this.card.style.transform = `translate3d(0, ${this.botSnap}px, 0)`;
		}
	}

	getTouches(e) {
		return e.touches || e.originalEvent.touches;
	}

	touchStart(e) {
		const firstTouch = this.getTouches(e)[0];
		this.yDown = firstTouch.clientY;
	}

	touchMove(e) {
		if (this.state === 'hidden') return;
		if (!this.yDown) return;
		if (this.inner.scrollTop > 0) return;
		if (!e.composedPath().some(el => el === this.card)) return;

		let yUp = e.touches[0].clientY;
		let yDiff = this.yDown - yUp;

		if (yDiff > 0) {
			this.open();
		} else {
			this.close();
		}
		this.yDown = null;
	}

	toggle(e) {
		e.stopPropagation();
		if (e.target !== this.toggler) return;
		document.dispatchEvent(new Event("toggleslideover"));

		e.preventDefault();
		// if (this.state === 'open') {
		// 	this.close();
		// } else {
		// 	this.open();
		// }
	}

	handleMoving() {
		this.moving = true;
		setTimeout(() => {
			this.moving = false;
		}, 500);
	}

	open() {
		this.handleMoving();
		if (this.state === 'open') return;
		this.setState('open');
		this.card.style.transform = `translate3d(0, ${this.topSnap}px, 0)`;
		this.bodyInner.style.overflowY = 'hidden';
	}

	close() {
		this.handleMoving();
		if (this.state === 'closed' || this.state === 'hidden') return;
		this.setState('closed');
		this.card.style.transform = `translate3d(0, ${this.botSnap}px, 0)`;
		this.bodyInner.style.overflowY = this.defaultOverflow;
	}

	hide() {
		if (this.state === 'hidden') return;
		this.setState('hidden');
		this.card.style.transform = `translate3d(0, 100vh, 0)`;
		this.bodyInner.style.overflowY = this.defaultOverflow;
	}

	setState(state) {
		this.state = state;
		this.card.setAttribute('data-state', state);
	}

	wrapInner() {
		const inner = this.card.innerHTML;
		this.card.innerHTML = '';
		this.inner = document.createElement('div');
		this.inner.classList.add('slide-over__inner');
		this.inner.innerHTML = inner;
		this.card.appendChild(this.inner);
	}

	appendToggler() {
		this.toggler = document.createElement('button');
		this.toggler.title = 'Toggle slide over';
		this.toggler.classList.add('slide-over__toggler');
		this.card.prepend(this.toggler);
	}
}

export default SlideOver;
